import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { startOfDay } from 'date-fns';
import { Button } from 'seagull';
import { BillClientModal } from '~/components/BillModal/BillClientModal/BillClientModal';
import { createEmptyChargeItem } from '~/components/BillModal/utils/lineItem.utils';
import { useOverlayContext, useIoContext, useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { Intent } from '~/infra/access-control';
import { timeModel } from '~/models';
import AddCreditModal from '../../../../components/AddCreditModal/AddCreditModal';
import styles from './BillingControl.module.scss';
export default function BillingControlFooter(props) {
    const { agreement, invoiceDateInfo, earliestBillableDate, controlData, onMobileAddCredit } = props;
    const { manualServices, totalCredits } = props.controlData;
    const { t: amTexts } = useLocaleKeys('pages.agreementMinisite');
    const { logBI } = useStoreActions();
    const { getNow } = useIoContext();
    const overlayContext = useOverlayContext();
    const onAddCredit = ()=>{
        logBI(18000);
        if (onMobileAddCredit) {
            onMobileAddCredit();
            return;
        }
        const nextBillingDate = timeModel.toDateStampObject((invoiceDateInfo === null || invoiceDateInfo === void 0 ? void 0 : invoiceDateInfo.selectedDate) || startOfDay(getNow()));
        overlayContext.showModal({
            biName: 'add_credit_modal',
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(AddCreditModal, {
                    relationship: agreement,
                    nextBillingDate: nextBillingDate,
                    dismissModal: dismissModal
                });
            }
        });
    };
    const onAddCharge = ()=>{
        logBI(10566);
        overlayContext.showModal({
            biName: 'bill_client_modal',
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(BillClientModal, {
                    dismissModal: dismissModal,
                    relationshipId: agreement.id,
                    invoiceDateInfo: invoiceDateInfo,
                    totalCredits: totalCredits,
                    earliestBillableDate: earliestBillableDate,
                    defaultItem: createEmptyChargeItem(),
                    manualServicesBilling: manualServices,
                    controlData: controlData
                });
            }
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.footer,
        children: [
            /*#__PURE__*/ _jsx(Button, {
                className: styles.footerBtn,
                skin: "primaryOutline",
                onClick: onAddCharge,
                testId: "add-charge-button",
                bi: {
                    name: 'add_charge'
                },
                intent: Intent.AddCharge,
                children: amTexts.addCharge()
            }),
            /*#__PURE__*/ _jsx(Button, {
                className: styles.footerBtn,
                skin: "primaryOutline",
                onClick: onAddCredit,
                testId: "add-credit-button",
                bi: {
                    name: 'add_credit'
                },
                intent: Intent.AddCredit,
                children: amTexts.addCredit()
            })
        ]
    });
}
